import { render, staticRenderFns } from "./NewLgbTeamMembersList.vue?vue&type=template&id=2b17c5e2"
import script from "./NewLgbTeamMembersList.vue?vue&type=script&lang=js"
export * from "./NewLgbTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./NewLgbTeamMembersList.vue?vue&type=style&index=0&id=2b17c5e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports